import styles from "./Tag.module.css";
const Tag: React.FC<{
  label: React.ReactNode | string;
  icon: React.ReactNode;
  light?: boolean;
}> = ({ label, icon, light }) => {
  return (
    <span className={`${styles.tag} ${light ? styles.light : ""}`}>
      {icon}
      <span>{label}</span>
    </span>
  );
};

export default Tag;
